(function(){
document.querySelectorAll('.cfpg').forEach(init);
function init(root){
var grid=root.querySelector('.cfpg-grid');if(!grid)return;
var empty=root.querySelector('.cfpg-empty-state');
var active={origin:'all',type:'all',milk:'all'};
var ignore=(root.dataset.ignore||'').split(',').map(function(s){return s.trim();});
var mt=root.dataset.money||'HK$123,456';
var dec=/[.,]\d\d$/.test(mt)?2:0;var cur=mt.split('1')[0];
function fmt(p){return cur+Number(p).toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
function apply(){var v=0;grid.querySelectorAll('.cfpg-card').forEach(function(c){
var s=(active.origin==='all'||c.dataset.origin===active.origin)&&(active.type==='all'||c.dataset.type===active.type)&&(active.milk==='all'||c.dataset.milk===active.milk);
c.classList.toggle('cfpg-hidden',!s);if(s)v++;});
if(empty)empty.style.display=v?'none':'block';}
function add(b){if(b.disabled)return;var id=b.dataset.variantId;b.disabled=true;var o=b.textContent;b.textContent='Adding…';
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
.then(function(r){return r.json();})
.then(function(){b.textContent='Added ✓';b.classList.add('added');setTimeout(function(){b.textContent=o;b.classList.remove('added');b.disabled=false;},1600);})
.catch(function(){b.textContent='Try again';b.disabled=false;});}
root.addEventListener('click',function(e){
var p=e.target.closest('.cfpg-pill');
if(p){var g=p.parentNode;g.querySelectorAll('.cfpg-pill').forEach(function(x){x.classList.remove('active');});p.classList.add('active');active[g.dataset.filterType]=p.dataset.value;apply();return;}
var b=e.target.closest('button.cfpg-add-btn');if(b)add(b);});
function pill(type,val){var g=root.querySelector('.cfpg-pills[data-filter-type="'+type+'"]');if(!g||!val)return;
var ex=g.querySelectorAll('.cfpg-pill');for(var i=0;i<ex.length;i++){if(ex[i].dataset.value===val)return;}
var b=document.createElement('button');b.type='button';b.className='cfpg-pill';b.dataset.value=val;b.textContent=val;
var ref=null;for(var j=1;j<ex.length;j++){if(ex[j].dataset.value.localeCompare(val)>0){ref=ex[j];break;}}
g.insertBefore(b,ref);}
function classify(tags){var o='',t='',m='';tags.forEach(function(tag){
if(tag.indexOf('Milk')>-1)m=tag;else if(tag.indexOf('Cheese')>-1)t=tag;else if(ignore.indexOf(tag)>-1){}else o=tag;});
return {o:o,t:t,m:m};}
var seen={};grid.querySelectorAll('.cfpg-card').forEach(function(c){seen[c.dataset.handle]=1;});
var h=root.dataset.handle;if(!h)return;
function load(page){
fetch('/collections/'+h+'/products.json?limit=250&page='+page).then(function(r){return r.json();}).then(function(d){
var ps=d.products||[];if(!ps.length)return;
ps.forEach(function(p){if(seen[p.handle])return;seen[p.handle]=1;
var c=classify(p.tags||[]);
var v=p.variants.filter(function(x){return x.available;})[0]||p.variants[0];
var board=p.handle==='cheese-board-per-person';
var link=board?'/pages/build-your-board':'/products/'+p.handle;
var img=p.images&&p.images[0]?p.images[0].src:'';
if(img)img+=(img.indexOf('?')>-1?'&':'?')+'width=500';
var meta=[c.o,c.t,c.m].filter(Boolean).join(' · ');
var btn=board?'<a href="'+link+'" class="cfpg-add-btn" style="text-decoration:none;display:flex;align-items:center;justify-content:center;">Build your board</a>':'<button type="button" class="cfpg-add-btn" data-variant-id="'+v.id+'"'+(v.available?'':' disabled')+'>'+(v.available?'Add to basket':'Sold out')+'</button>';
var el=document.createElement('div');el.className='cfpg-card';
el.dataset.origin=c.o;el.dataset.type=c.t;el.dataset.milk=c.m;el.dataset.handle=p.handle;
el.innerHTML='<a href="'+link+'" class="cfpg-media-link"><div class="cfpg-media">'+(img?'<img src="'+esc(img)+'" alt="'+esc(p.title)+'" loading="lazy">':'<div class="cfpg-media-fallback">🧀</div>')+'</div></a><div class="cfpg-card-body"><h4><a href="'+link+'">'+esc(p.title)+'</a></h4>'+(meta?'<p class="cfpg-meta">'+esc(meta)+'</p>':'')+'<div class="cfpg-price-row"><span class="cfpg-price">'+fmt(v.price)+'</span>'+btn+'</div></div>';
grid.appendChild(el);pill('origin',c.o);pill('type',c.t);pill('milk',c.m);});
apply();if(ps.length>=250)load(page+1);
}).catch(function(){});}
load(1);
}
})();